/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取旗舰店演出分类
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<dictionary.ProductCategoryDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/shop/categories`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
